import React from 'react';

import PropTypes from 'prop-types';

import { PanelContainerBlock, PanelContainerLink } from './styles';

const getComponent = (type) => {
    switch (type) {
        case 'link':
            return PanelContainerLink;
        default:
            return PanelContainerBlock;
    }
};

export const LightPanel = (props) => {
    const Wrapper = getComponent(props.type);

    return (
        <Wrapper
            $isBordered={props.isBordered}
            $hasBorderRadius={props.hasBorderRadius}
            $negativeMargin={props.negativeMargin}
            $isHoverable={props.isHoverable}
            href={props.href}
            to={props.to}
            onClick={(e) => props.onClick?.(e)}
            type={props.type}
        >
            {props.children}
        </Wrapper>
    );
};

LightPanel.propTypes = {
    type: PropTypes.oneOf(['div', 'link']),
    isBordered: PropTypes.bool,
    hasBorderRadius: PropTypes.bool,
    negativeMargin: PropTypes.bool,
    isHoverable: PropTypes.bool,
    href: PropTypes.string,
    to: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node,
};
